export const MOBILE_VIEWPORT_MAX_WIDTH = 768

export const MOBILE_VIEWPORT_MEDIA_QUERY = `(max-width: ${MOBILE_VIEWPORT_MAX_WIDTH}px)`

export function isMobileViewport(): boolean {
  if (typeof globalThis.matchMedia !== 'function') return false
  return globalThis.matchMedia(MOBILE_VIEWPORT_MEDIA_QUERY).matches
}

export function isMobileAccessAllowed(): boolean {
  return import.meta.env.VITE_ALLOW_MOBILE === 'true'
}

export function shouldBlockMobileViewport(): boolean {
  return isMobileViewport() && !isMobileAccessAllowed()
}
